import api from "@/api.js";

export default {
  state: {
    users: [],
    usersLoading: false
  },
  mutations: {
    setUsers(state, users) {
      state.users = users;
    },
    setUsersLoading(state, loading) {
      state.usersLoading = loading;
    }
  },
  actions: {
    async loadUsers({ commit, dispatch }) {
      commit("setUsersLoading", true);
      let users = await api.get("users");
      commit("setUsers", users.data);
      commit("setUsersLoading", false);
    },
    async newUser({ commit, dispatch }, payload) {
      commit("setUsersLoading", true);
      let data = {
        email: payload.email,
        emailVerified: true,
        displayName: payload.name,
        disabled: false
      };
      let newUser = await api.post("users/createFirebaseUser", data);
      if (newUser.data.Result == "Success") {
        dispatch("loadUsers");
        return "Success";
      } else {
        return "User Could not be added";
      }
    },
    async saveUser({ commit, dispatch }, payload) {
      commit("setUsersLoading", true);
      let saveUser = await api.put("users", payload);
      if (saveUser.data.Result == "Success") {
        dispatch("loadUsers");
        return "Success";
      } else {
        return "User Could not be added";
      }
    }
  },
  getters: {
    usersLoading(state) {
      return state.usersLoading;
    },
    users(state) {
      return state.users;
    }
  }
};
